// extracted by mini-css-extract-plugin
export var fullWidthButton = "_qx-0";